import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Utils } from 'src/app/services/utils/utils.service';
import { environment } from 'src/environments/environment';

declare let gtag: any;

// singleton service - don't include it in any component's providers []
@Injectable({ providedIn: 'root' })
export class tagManagerService {
    isTagManagerAdded = false;

    constructor(private cookieService: CookieService, private utils: Utils) {
        this.utils.log('tagManagerService.constructor');
    }

    enableGoogleTagManager(): void {
        if (this.isTagManagerAdded) {
            return;
        }
        if (environment.brand != 'audi')
        {
            return;
        }

        try {
            this.utils.log('Enabling Google TagManager');
            const script = document.createElement('script');
            //script.async = true;
            script.text = `
            <!-- Google Tag Manager --> 
            (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','${environment.googleTagManagerId}');
            `;
            document.head.prepend(script);


            const script1 = document.createElement('noscript');
            //script.async = true;
            script.text = `
            <!-- Google Tag Manager (noscript) --> 
            <iframe src="https://www.googletagmanager.com/ns.html?id=${environment.googleTagManagerId}"
            height="0" width="0" style="display:none;visibility:hidden"></iframe>
            <!-- End Google Tag Manager (noscript) -->
            `;
            document.body.prepend(script1);


            this.isTagManagerAdded = true;
        } catch (error) {
          this.utils.log('enable Google TagManager', error);
        }
    }
}
